import { Result } from "antd";
import { useTranslation } from "react-i18next";

export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <Result
      status="403"
      title={t("errors.403")}
      subTitle={t("common.forbiddenHint")}
    />
  );
}
